export const SHOW_INLINE_GLOSSARY_DEFINITIONS_KEY =
  'side-app-show-glossary-inline-definitions';

export const GLOSSARY_DEFINITIONS = [
  {
    category: 'Goals',
    items: [
      {
        matches: ['Volume Goal'],
        title: 'Sales Volume Goal',
        definition:
          "The total dollar value of closed transactions you're aiming to achieve in a given time period",
      },
      {
        title: 'Average Sale Price Goal',
        definition:
          "The average sale price you're targeting across all closed transactions",
      },
      {
        title: 'Sides Goal',
        definition:
          "The total count of transaction sides (buy or sell representations) you're aiming to close",
      },
    ],
  },
  {
    category: 'Performance',
    items: [
      {
        matches: ['Total Transactions'],
        title: 'Total Transactions',
        definition:
          'The total number of transaction sides closed (each buy or sell representation counts as one side)',
      },
      {
        title: 'Weighted Transactions',
        definition:
          'Your portion of transaction sides after applying an agent allocation percentage',
      },
      {
        matches: ['Volume', 'Prior Year Volume'],
        title: 'Sales Volume',
        definition:
          'The total dollar value of properties closed during the selected time period',
      },
      {
        title: 'Weighted Sale Volume',
        definition:
          'Your portion of total sales volume after applying an agent allocation percentage to each transaction',
      },
      {
        title: 'Average Sale Value',
        definition:
          'The average sale price across all closed transactions in the selected period',
      },
      {
        title: 'Average Commission %',
        definition: 'The average commission % across all closed transactions',
      },
      {
        title: 'Average Commission Amount',
        definition:
          'The average post-referral GCI amount per closed transaction',
      },
    ],
  },
  {
    category: 'Commission',
    items: [
      {
        title: 'Deal Value',
        definition: 'The price at which a specific property closed',
      },
      {
        title: 'Commission Percentage',
        definition:
          'The commission rate applied to the sale price to calculate gross commission',
      },
      {
        title: 'GCI (Gross Commission Income)',
        definition:
          'The total commission generated from closed transactions before any deductions or splits',
      },
      {
        title: 'Pre-Split Deductions',
        definition:
          'Costs deducted from GCI before commission splits are applied (e.g., referrals or other transaction-level deductions)',
      },
      {
        matches: ['Post-Referral GCI', 'Prior Year Post-Referral GCI'],
        title: 'Post-Referral GCI',
        definition:
          'GCI after referrals (and other pre-split deductions) are removed, but before any team, agent, or brokerage splits are applied',
      },
    ],
  },
  {
    category: 'Allocation',
    items: [
      {
        title: 'Agent Allocation %',
        definition:
          'The percentage of a transaction credited to you when a deal is shared with other agents',
      },
      {
        matches: ['My Weighted GCI'],
        title: 'Agent Weighted GCI',
        definition:
          'Your portion of Post-Referral Gross Commission after applying your allocation percentage',
      },
    ],
  },
  {
    category: 'Splits',
    items: [
      {
        title: 'Agent Split %',
        definition:
          'The percentage of commission allocated to the agent after brand and/or team splits are applied',
      },
      {
        matches: ['My Gross Commission'],
        title: 'Agent Gross',
        definition:
          "The agent's portion of commission before fees are deducted",
      },
      {
        title: 'Brand Split %',
        definition:
          'The percentage of commission allocated to the brand based on your split agreement',
      },
      {
        title: 'Brand Gross',
        definition:
          "The brand's portion of commission before fees are deducted",
      },
      {
        title: 'Team Split %',
        definition:
          'The percentage of commission allocated to a team based on the team agreement',
      },
      {
        title: 'Team Gross',
        definition: "The team's portion of commission before fees are deducted",
      },
      {
        title: 'Side Split %',
        definition:
          'The percentage of commission allocated to be retained by Side',
      },
      {
        title: 'Side Gross',
        definition: 'The commission amount allocated to be retained by Side',
      },
    ],
  },
  {
    category: 'Fees',
    items: [
      {
        matches: ['Agent Net'],
        title: 'Agent Net Fees',
        definition: "Fees deducted from the agent's gross commission",
      },
      {
        matches: ['Team Net', 'Team Fees Received'],
        title: 'Team Net Fees',
        definition: "Fees deducted from the team's gross commission",
      },
      {
        matches: ['Brand Fees Received', 'Brand Net'],
        title: 'Brand Net Fees',
        definition: "Fees deducted from the brand's gross commission",
      },
      {
        matches: ['Side Net'],
        title: 'Side Net Fees',
        definition:
          'Fees deducted at the transaction side level (used in limited scenarios)',
      },
      {
        title: 'Team Fees Received',
        definition: 'Fees that were received by the sub-team',
      },
      {
        title: 'Brand Fees Received',
        definition: 'Fees that were received by the brand',
      },
    ],
  },
  {
    category: 'Take-Home Commission',
    items: [
      {
        title: 'Brand Net Commission',
        definition:
          "The brand's final commission amount after all splits and fees",
      },
      {
        title: 'Team Net Commission',
        definition:
          "The team's final commission amount after all splits and fees",
      },
      {
        title: 'Side Net Commission',
        definition:
          'The final commission amount at the side level after all splits and fees',
      },
      {
        title: 'Agent Net Commission',
        definition:
          "The agent's final take-home commission after all splits and fees",
      },
      {
        title: 'Client Referrals Received',
        definition:
          "The agent's final take-home commission from client referrals",
      },
    ],
  },
];
